module.exports = __webpack_public_path__ + "img/icn_scarpa_bianca_selezionata.7b37dadc.png";